<h2>Horarios MiGlm</h2>
<a [routerLink]="['/horario', 'importar']">
  <button mat-raised-button color="primary">Importar nuevo horario</button>
</a>
<table mat-table [dataSource]="horarios$ | async" class="mat-elevation-z4 full-width">
  <ng-container matColumnDef="escuela">
    <th mat-header-cell *matHeaderCellDef> Escuela </th>
    <td mat-cell *matCellDef="let element"> {{element.escuelaNombre}} </td>
  </ng-container>
  <ng-container matColumnDef="fecha">
    <th mat-header-cell *matHeaderCellDef> Fecha inicio </th>
    <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date: 'medium'}} </td>
  </ng-container>
  <ng-container matColumnDef="menu">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
    <button mat-menu-item (click)="eliminar(element.escuelaId, element.fechaInicio)"><mat-icon>delete</mat-icon></button>
    <!-- <mat-menu #appMenu="matMenu">
      <button mat-menu-item (click)="eliminar(element.escuelaId, element.fechaInicio)">Eliminar</button>
      <button mat-menu-item (click)="ver(element)">Ver</button>
    </mat-menu>
    <button mat-icon-button [matMenuTriggerFor]="appMenu">
      <mat-icon>more_vert</mat-icon>
    </button> -->
  </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="['escuela', 'fecha', 'menu']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['escuela', 'fecha', 'menu'];"></tr>
</table>
